import React, { Component } from "react";
import { Grid, Box } from "@mui/material";
import CtTxtNum from "./CustomTool/CtTxtNum";
import CtTxtAmt from "./CustomTool/CtTxtAmt";
import CtTxt from "./CustomTool/CtTxt";
import CtBtn from "./CustomTool/CtBtn";
import CtCmb from "./CustomTool/CtCmb";
import CtCmbEditable from "./CustomTool/CtCmbEditable";
import CtMultiLineText from "./CustomTool/CtMultiLineText";
import { connect } from "react-redux";
import {
  mapStatetoProps,
  mapSetActiveMenuToProps,
} from "../mapRedux/mapReduxProps";
import { fetchSales } from "./API";
import AlertResponsiveDialog from "./CustomTool/AlertResponsiveDialog";
import TaxMaster from "./TaxMaster";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import {
  applyTrimOnObjectValues,
  getTaxNumFromStr,
  getTaxableFromValue,
  get_YMD_from_SYS,
  isValidItem,
  roundOff,
  setTaxPaidRate,
  validatedate_min_max,
} from "../SystemUtility/SystemUtility";
import ItemMaster from "./ItemMaster";
import SetTaxPaidRate from "./SetTaxPaidRate";
import CtDtp from "./CustomTool/CtDtp";

class SalesEWayBill extends Component {
  state = {
    SubSupplyTypeList: [
      "Supply",
      "Export",
      "Job Work",
      "SKD/CKD/Lots",
      "Recipient Not Known",
      "For Own Use",
      "Exhibition or Fairs",
      "Line Sales",
      "Others",
    ],
    TransactionTypeList: [
      "Regular",
      "Bill To - Ship To",
      "Bill From - Dispatch From",
      "Combination of 2 and 3",
    ],
    ModeofTransportationList: [
      "Road",
      "Air",
      "Train",
      "Ship or Ship Cum Road/Rail",
    ],
    SubTypeOtherSpecifyList: [],
    DocumentTypeList: [],
    DispatchPlaceList: [],
    DispatchStateList: [],
    ShipToStateList: [],
    ShipToPlaceList: [],
    TransporterNameList: [],
    TransporterIDList: [],
    VehicleNoList: [],
    VehicleTypeList: ["Regular", "Over Dimensional Cargo"],
    edit_salessrno: "",
    CustomerData: [],
    StateList: [],
    EWayBillData: [],
    formData: {
      cmbSupplyType: "",
      cmbSubSupplyType: "",
      cmbSubTypeOtherSpecify: "",
      cmbDocumentType: "",
      txtDocumentNo: "",
      dtpDocumentDate: "",
      cmbTransactionType: "",
      txtDispatchAddress1: "",
      txtDispatchAddress2: "",
      cmbDispatchPlace: "",
      txtDispatchPincode: "",
      cmbDispatchState: "",
      txtShipToAddress1: "",
      txtShipToAddress2: "",
      cmbShipToPlace: "",
      txtShipToPincode: "",
      cmbShipToState: "",
      txtTotalValue: "",
      txtTotalCGST: "",
      txtTotalSGST: "",
      txtTotalIGST: "",
      txtTotalInvoiceValue: "",
      cmbModeofTransportation: "",
      txtApproximateDistanceinKM: "",
      cmbTransporterName: "",
      cmbTransporterID: "",
      txtTransporterDocNo: "",
      dtpTransporterDate: "",
      cmbVehicleNo: "",
      cmbVehicleType: "",
    },
    dataLoadStatus: true,
    ARD: null,
  };

  //#region Component
  componentDidMount() {
    document.title = "RiTe Account : Sales E-Way Bill Entry";
    this.props.setActiveMenu("SalesEWayBillEntry");
    this.onFormLoad();
  }

  componentWillReceiveProps(newProps) {
    // console.log("newProps",newProps);
    if (
      (newProps.ItemNameList &&
        this.state.ItemNameList &&
        newProps.ItemNameList.length !== this.state.ItemNameList.length) ||
      (newProps.StoreNameList &&
        this.state.StoreNameList &&
        newProps.StoreNameList.length !== this.state.StoreNameList.length)
    ) {
      let ItemNameList = newProps.ItemNameList,
        StoreNameList = newProps.StoreList;
      this.setState({ ItemNameList, StoreNameList });
    }
  }
  //#endregion Component

  //#region handle

  onSubSupplyTypeChange = () => {
    // if (e.target.name == "cmbSubSupplyType") {
    let DocumentTypeList = [],
      DefaultDocType = "";
    if (this.state.formData.cmbSubSupplyType === "Supply") {
      DocumentTypeList = ["Tax Invoice", "Bill of Supply"];
      DefaultDocType = "Tax Invoice";
    } else if (this.state.formData.cmbSubSupplyType === "Export") {
      DocumentTypeList = ["Tax Invoice", "Bill of Supply"];
      DefaultDocType = "Bill of Supply";
    } else if (this.state.formData.cmbSubSupplyType === "Job Work") {
      DocumentTypeList = ["Delivery Challan"];
      DefaultDocType = "Delivery Challan";
    } else if (this.state.formData.cmbSubSupplyType === "SKD/CKD/Lots") {
      DocumentTypeList = ["Tax Invoice", "Bill of Supply", "Delivery Challan"];
      DefaultDocType = "Delivery Challan";
    } else if (this.state.formData.cmbSubSupplyType === "Recipient Not Known") {
      DocumentTypeList = ["Delivery Challan", "Others"];
      DefaultDocType = "Delivery Challan";
    } else if (this.state.formData.cmbSubSupplyType === "For Own Use") {
      DocumentTypeList = ["Delivery Challan"];
      DefaultDocType = "Delivery Challan";
    } else if (this.state.formData.cmbSubSupplyType === "Exhibition or Fairs") {
      DocumentTypeList = ["Delivery Challan"];
      DefaultDocType = "Delivery Challan";
    } else if (this.state.formData.cmbSubSupplyType === "Line Sales") {
      DocumentTypeList = ["Delivery Challan"];
      DefaultDocType = "Delivery Challan";
    } else if (this.state.formData.cmbSubSupplyType === "Others") {
      DocumentTypeList = ["Delivery Challan", "Others"];
      DefaultDocType = "Delivery Challan";
    }
    this.setState({
      DocumentTypeList,
      formData: {
        ...this.state.formData,
        cmbDocumentType: DefaultDocType,
      },
    });
    // }
  };

  handleOnChange = (e) => {
    this.setState(
      {
        formData: { ...this.state.formData, [e.target.name]: e.target.value },
      },
      () => {
        console.log("handleOnChange", this.state.formData);
        if (e.target.name == "cmbSubSupplyType") {
          this.onSubSupplyTypeChange();
        }
      }
    );
  };
  //#endregion handle

  //#region function

  trimFormData = (nextFunctionCall) => {
    let formData = applyTrimOnObjectValues({
      formData: this.state.formData,
    });
    // console.log("formData", formData);
    this.setState({ formData }, () => {
      if (nextFunctionCall) {
        nextFunctionCall();
      }
    });
  };

  validateSalesEWayBill = () => {
    let result = false;

    // this.trimFormData(() => {
    console.log("this.state.formData", this.state.formData);
    if (this.state.formData.cmbSubSupplyType.length <= 0) {
      this.props.toastErrorMsg("Select Sub Supply Type", "cmbSubSupplyType");
    } else if (
      !isValidItem(
        this.state.SubSupplyTypeList,
        "",
        this.state.formData.cmbSubSupplyType
      )
    ) {
      this.props.toastErrorMsg(
        "Select Valid Sub Supply Type",
        "cmbSubSupplyType"
      );
    } else if (this.state.formData.cmbDocumentType.length <= 0) {
      this.props.toastErrorMsg("Select Document Type", "cmbDocumentType");
    } else if (
      !isValidItem(
        this.state.DocumentTypeList,
        "",
        this.state.formData.cmbDocumentType
      )
    ) {
      this.props.toastErrorMsg("Select Valid Document Type", "cmbDocumentType");
    } else if (this.state.formData.txtDocumentNo.length <= 0) {
      this.props.toastErrorMsg("Invalid Document No", "txtDocumentNo");
    } else if (this.state.formData.dtpDocumentDate.length <= 0) {
      this.props.toastErrorMsg("Enter Document Date", "dtpDocumentDate");
    } else if (
      validatedate_min_max(
        this.state.formData.dtpDocumentDate,
        "dtpDocumentDate",
        this.props.toastErrorMsg
      ) == false
    ) {
      return false;
    } else if (this.state.formData.cmbTransactionType.length <= 0) {
      this.props.toastErrorMsg("Select Transaction Type", "cmbTransactionType");
    } else if (
      !isValidItem(
        this.state.TransactionTypeList,
        "",
        this.state.formData.cmbTransactionType
      )
    ) {
      this.props.toastErrorMsg(
        "Select Valid Transaction Type",
        "cmbTransactionType"
      );
    } else if (this.state.formData.txtDispatchPincode.length <= 0) {
      this.props.toastErrorMsg("Enter Dispatch Pincode", "txtDispatchPincode");
    } else if (this.state.formData.txtDispatchPincode.length < 6) {
      this.props.toastErrorMsg(
        "Enter valid Dispatch Pincode",
        "txtDispatchPincode"
      );
    } else if (this.state.formData.txtShipToPincode.length <= 0) {
      this.props.toastErrorMsg("Enter Ship to Pincode", "txtShipToPincode");
    } else if (this.state.formData.txtDispatchPincode.length < 6) {
      this.props.toastErrorMsg(
        "Enter valid Ship to Pincode",
        "txtShipToPincode"
      );
    } else if (Number(this.state.formData.txtApproximateDistanceinKM) <= 0) {
      this.props.toastErrorMsg(
        "Enter Approximate Distance in KM",
        "txtApproximateDistanceinKM"
      );
    } else {
      // console.log("result 1", result);
      result = true;
      // return true;
      // console.log("result 2", result);
    }
    // console.log("result", result);
    // return result;
    // return false;
    // });
    // console.log("result", result);
    return result;
  };

  validatePincode = () => {
    let result = false;
    if (this.state.formData.txtDispatchPincode.length <= 0) {
      this.props.toastErrorMsg("Enter Dispatch Pincode", "txtDispatchPincode");
    } else if (this.state.formData.txtDispatchPincode.length < 6) {
      this.props.toastErrorMsg(
        "Enter valid Dispatch Pincode",
        "txtDispatchPincode"
      );
    } else if (this.state.formData.txtShipToPincode.length <= 0) {
      this.props.toastErrorMsg("Enter Ship to Pincode", "txtShipToPincode");
    } else if (this.state.formData.txtDispatchPincode.length < 6) {
      this.props.toastErrorMsg(
        "Enter valid Ship to Pincode",
        "txtShipToPincode"
      );
    } else {
      result = true;
    }
    return result;
  };

  onFormLoad = () => {
    let dataLoadStatus = false;
    this.setState({ dataLoadStatus }, () => {
      let SubTypeOtherSpecifyList = [],
        DocumentTypeList = [],
        DispatchPlaceList = [],
        DispatchStateList = [],
        ShipToStateList = [],
        ShipToPlaceList = [],
        TransporterNameList = [],
        TransporterIDList = [],
        VehicleNoList = [],
        edit_salessrno = 0,
        CustomerData = [],
        EWayBillData = [];
      if (this.props.EWayBillData) {
        EWayBillData = this.props.EWayBillData[0];
        SubTypeOtherSpecifyList =
          this.props.EWayBillData.CmbData.SubSupplyTypeOther;
        DispatchPlaceList = this.props.EWayBillData.CmbData.FromPlace;
        ShipToPlaceList = this.props.EWayBillData.CmbData.ToPlace;
        DispatchStateList = this.props.StateList;
        ShipToStateList = this.props.StateList;
        TransporterNameList = this.props.EWayBillData.CmbData.TransporterName;
        TransporterIDList = this.props.EWayBillData.CmbData.TransporterId;
        VehicleNoList = this.props.EWayBillData.CmbData.VehicleNo;
        edit_salessrno = this.props.edit_salessrno;
        CustomerData = this.props.CustomerData;

        this.setState(
          {
            SubTypeOtherSpecifyList,
            DocumentTypeList,
            DispatchPlaceList,
            DispatchStateList,
            ShipToStateList,
            ShipToPlaceList,
            TransporterNameList,
            TransporterIDList,
            VehicleNoList,
            edit_salessrno,
            dataLoadStatus: true,
            CustomerData,
            EWayBillData,
            formData: {
              ...this.state.formData,
              dtpDocumentDate: this.props.dtpDate,
              dtpTransporterDate: get_YMD_from_SYS(new Date()),
              txtDocumentNo: this.props.txtBillNo,
              txtTotalValue: this.props.txtTaxable,
              txtTotalCGST: this.props.txtCGST,
              txtTotalSGST: this.props.txtSGST,
              txtTotalIGST: this.props.txtIGST,
              txtTotalInvoiceValue: this.props.txtGrandTotal,
            },
          },
          () => {
            if (EWayBillData) {
              this.setState(
                {
                  formData: {
                    ...this.state.formData,
                    cmbSupplyType: EWayBillData.vac_supplytype,
                    cmbSubSupplyType: EWayBillData.vac_subsupplytype,
                  },
                },
                () => {
                  this.onSubSupplyTypeChange();
                  this.setState({
                    formData: {
                      ...this.state.formData,
                      cmbSubTypeOtherSpecify:
                        EWayBillData.vac_subsupplytypeother,
                      cmbDocumentType: EWayBillData.vac_doctype,
                      // txtDocumentNo: EWayBillData.vac_docno,
                      dtpDocumentDate: EWayBillData.dat_docdate,
                      cmbTransactionType: EWayBillData.vac_transtype,
                      txtDispatchAddress1: EWayBillData.vac_fromaddr1,
                      txtDispatchAddress2: EWayBillData.vac_fromaddr2,
                      cmbDispatchPlace: EWayBillData.vac_fromplace,
                      txtDispatchPincode: EWayBillData.vac_frompincode,
                      cmbDispatchState: EWayBillData.vac_fromstate,
                      txtShipToAddress1: EWayBillData.vac_toaddr1,
                      txtShipToAddress2: EWayBillData.vac_toaddr2,
                      cmbShipToPlace: EWayBillData.vac_toplace,
                      txtShipToPincode: EWayBillData.vac_topincode,
                      cmbShipToState: EWayBillData.vac_tostate,
                      txtApproximateDistanceinKM:
                        EWayBillData.dec_transdistance,
                      txtDocumentNo: this.props.txtBillNo,
                      txtTotalValue: this.props.txtTaxable,
                      txtTotalCGST: this.props.txtCGST,
                      txtTotalSGST: this.props.txtSGST,
                      txtTotalIGST: this.props.txtIGST,
                      txtTotalInvoiceValue: this.props.txtGrandTotal,
                      cmbModeofTransportation: EWayBillData.vac_transmode,
                      txtApproximateDistanceinKM:
                        EWayBillData.dec_transdistance,
                      cmbTransporterName: EWayBillData.vac_transportername,
                      cmbTransporterID: EWayBillData.vac_transporterid,
                      txtTransporterDocNo: EWayBillData.vac_transdocno,
                      dtpTransporterDate: EWayBillData.dat_transdocdate,
                      cmbVehicleNo: EWayBillData.vac_vehicleno,
                      cmbVehicleType: EWayBillData.vac_vehicletype,
                    },
                  });
                }
              );
              // console.log("txtTotalAmt 1", this.state.formData.txtTotalAmt);
            }
            document.getElementById("cmbSubSupplyType").focus();
          }
        );
      }
    });
  };

  getDistanceFromPincode = () => {
    if (this.validatePincode()) {
      const jsonInfo = {
        process: "GetPincodeDistance",
        fromPincode: this.state.formData.txtDispatchPincode,
        toPincode: this.state.formData.txtShipToPincode,
      };
      const jsonString = JSON.stringify({ jsonInfo });
      navigator.clipboard.writeText('"RTW" ' + jsonString);
    }
  };

  saveEWayBill = () => {
    // console.log("this.validateSalesEWayBill()", this.validateSalesEWayBill());
    // console.log("this.props.userPrivilege.Sales");
    if (this.props.userPrivilege.Sales != "R") {
      this.trimFormData(() => {
        if (this.validateSalesEWayBill) {
          // console.log("this.state.formData from Save", this.state.formData);
          const dataLoadStatus = false;
          this.props.notifyProcessing();
          this.setState({ dataLoadStatus }, () => {
            let FromStateCode = 0;
            this.state.StateList.map((row) => {
              if (row.vac_state === this.state.formData.cmbDispatchState) {
                FromStateCode = row.vac_statecode;
              }
            });
            let ToStateCode = 0;
            this.state.StateList.map((row) => {
              if (row.vac_state === this.state.formData.cmbShipToState) {
                ToStateCode = row.vac_statecode;
              }
            });

            let CompanyStateName = "";
            this.state.StateList.map((row) => {
              if (row.vac_statecode === localStorage.getItem("CompStateCode")) {
                CompanyStateName = row.vac_state;
              }
            });
            const reqData = {
              Op: "SaveSales_Item",
              bint_ci: localStorage.getItem("CI"),
              vac_username: localStorage.getItem("UserName"),
              bint_acyear: this.props.bint_acyear,
              bolinvoiceprint: false,
              bint_acid: this.props.bint_acid,
              vac_company: this.props.cmbCompany,
              bint_salessrno: this.state.edit_salessrno,
              // bint_salessrno: this.props.edit_salessrno,
              dat_salesdate: this.props.dtpDate,
              vac_billtype: this.props.cmbBillType,
              vac_billno: this.props.txtBillNo,
              bint_billno: this.props.bint_billno,
              vac_customer: this.props.cmbCustomer,
              vac_customershipto: this.props.cmbShipTo,
              vac_referencename: this.props.cmbReference,
              dec_discamt: this.props.txtDiscount,
              dec_taxable: this.props.txtTaxable,
              dec_cgst: this.props.txtCGST,
              dec_sgst: this.props.txtSGST,
              dec_igst: this.props.txtIGST,
              dec_grtotal: this.props.txtGrandTotal,
              dec_tdsamount: this.props.txtTDSAmount,
              dec_advancepayment: this.props.txtAdvPayment,
              dec_roundoff: this.props.txtRoundOff,
              dec_netpayment: this.props.txtNetPayment,
              vac_salestransactiontype: this.props.cmbTransactionType,
              bint_vouno: 0,
              vac_remark: this.props.txtRemark,
              dec_beforetaxamt: this.props.dec_beforetaxamt,
              dec_aftertaxamt: this.props.dec_aftertaxamt,
              PaymentData:
                this.props.cmbTransactionType == "Paid"
                  ? this.props.rowsPaymentMode
                  : [],
              OtherDetailData: this.props.rowsOtherDetail,
              EWayBillData: {
                vac_supplytype: this.state.formData.cmbSupplyType,
                vac_subsupplytype: this.state.formData.cmbSubSupplyType,
                vac_subsupplytypeother:
                  this.state.formData.cmbSubTypeOtherSpecify,
                vac_doctype: this.state.formData.cmbDocumentType,
                vac_docno: this.state.formData.txtDocumentNo,
                dat_docdate: this.state.formData.dtpDocumentDate,
                vac_transtype: this.state.formData.cmbTransactionType,
                vac_fromaddr1: this.state.formData.txtDispatchAddress1,
                vac_fromaddr2: this.state.formData.txtDispatchAddress2,
                vac_fromplace: this.state.formData.cmbDispatchPlace,
                vac_frompincode: this.state.formData.txtDispatchPincode,
                vac_fromstatecode: FromStateCode,
                vac_fromstate: this.state.formData.cmbDispatchState,
                vac_actualfromstatecode: localStorage.getItem("CompStateCode"),
                vac_actualfromstate: CompanyStateName,
                vac_totrdname: this.props.cmbCustomer,
                vac_togstin: this.state.CustomerData["vac_gstin"],
                vac_toaddr1: this.state.formData.txtShipToAddress1,
                vac_toaddr2: this.state.formData.txtShipToAddress2,
                vac_toplace: this.state.formData.cmbShipToPlace,
                vac_topincode: this.state.formData.txtShipToPincode,
                vac_tostatecode: ToStateCode,
                vac_tostate: this.state.formData.cmbShipToState,
                vac_actualtostatecode: this.state.CustomerData["vac_statecode"],
                vac_actualtostate: this.state.CustomerData["vac_state"],
                dec_totalvalue: this.state.formData.txtTotalValue,
                dec_cgstvalue: this.state.formData.txtTotalCGST,
                dec_sgstvalue: this.state.formData.txtTotalSGST,
                dec_igstvalue: this.state.formData.txtTotalIGST,
                dec_cessvalue: 0,
                dec_totnonadvolval: 0,
                dec_othvalue: 0,
                vac_mainhsncode: "",
                dec_totInvValue: this.state.formData.txtTotalInvoiceValue,
                vac_transmode: this.state.formData.cmbModeofTransportation,
                dec_transdistance:
                  this.state.formData.txtApproximateDistanceinKM,
                vac_transportername: this.state.formData.cmbTransporterName,
                vac_transporterid: this.state.formData.cmbTransporterID,
                vac_transdocno: this.state.formData.txtTransporterDocNo,
                dat_transdocdate: this.state.formData.dtpTransporterDate,
                vac_vehicleno: this.state.formData.cmbVehicleNo,
                vac_vehicletype: this.state.formData.cmbVehicleType,
              },
            };
            // console.log("reqData", reqData);
            fetchSales(reqData)
              .then((res) => {
                this.props.updateProcessing(res.data.msgType, res.data.message);
                if (res.data.msgType === "success") {
                  this.props.setEwayBillARDNull(res.data.EWayBillData);
                }
              })
              .catch((error) => {
                console.log("Unknown error occurred in saveEWayBill.", error);
              });
          });
        }
      });
      // console.log("this.state.formData Before", this.state.formData);
      // if (this.validateSalesEWayBill) {
      //   console.log("this.state.formData from Save", this.state.formData);
      //   const dataLoadStatus = false;
      //   this.props.notifyProcessing();
      //   this.setState({ dataLoadStatus }, () => {
      //     let FromStateCode = 0;
      //     this.state.StateList.map((row) => {
      //       if (row.vac_state === this.state.formData.cmbDispatchState) {
      //         FromStateCode = row.vac_statecode;
      //       }
      //     });
      //     let ToStateCode = 0;
      //     this.state.StateList.map((row) => {
      //       if (row.vac_state === this.state.formData.cmbShipToState) {
      //         ToStateCode = row.vac_statecode;
      //       }
      //     });
      //     const reqData = {
      //       Op: "SaveSales_Item",
      //       bint_ci: localStorage.getItem("CI"),
      //       vac_username: localStorage.getItem("UserName"),
      //       bint_acyear: this.props.bint_acyear,
      //       bolinvoiceprint: false,
      //       bint_acid: this.props.bint_acid,
      //       vac_company: this.props.cmbCompany,
      //       bint_salessrno: this.state.edit_salessrno,
      //       // bint_salessrno: this.props.edit_salessrno,
      //       dat_salesdate: this.props.dtpDate,
      //       vac_billtype: this.props.cmbBillType,
      //       vac_billno: this.props.txtBillNo,
      //       bint_billno: this.props.bint_billno,
      //       vac_customer: this.props.cmbCustomer,
      //       vac_customershipto: this.props.cmbShipTo,
      //       vac_referencename: this.props.cmbReference,
      //       dec_discamt: this.props.txtDiscount,
      //       dec_taxable: this.props.txtTaxable,
      //       dec_cgst: this.props.txtCGST,
      //       dec_sgst: this.props.txtSGST,
      //       dec_igst: this.props.txtIGST,
      //       dec_grtotal: this.props.txtGrandTotal,
      //       dec_tdsamount: this.props.txtTDSAmount,
      //       dec_advancepayment: this.props.txtAdvPayment,
      //       dec_roundoff: this.props.txtRoundOff,
      //       dec_netpayment: this.props.txtNetPayment,
      //       vac_salestransactiontype: this.props.cmbTransactionType,
      //       bint_vouno: 0,
      //       vac_remark: this.props.txtRemark,
      //       dec_beforetaxamt: this.props.dec_beforetaxamt,
      //       dec_aftertaxamt: this.props.dec_aftertaxamt,
      //       PaymentData:
      //         this.props.cmbTransactionType == "Paid"
      //           ? this.props.rowsPaymentMode
      //           : [],
      //       OtherDetailData: this.props.rowsOtherDetail,
      //       EWayBillData: {
      //         vac_supplytype: this.state.formData.cmbSupplyType,
      //         vac_subsupplytype: this.state.formData.cmbSubSupplyType,
      //         vac_subsupplytypeother:
      //           this.state.formData.cmbSubTypeOtherSpecify,
      //         vac_doctype: this.state.formData.cmbDocumentType,
      //         vac_docno: this.state.formData.txtDocumentNo,
      //         dat_docdate: this.state.formData.dtpDocumentDate,
      //         vac_transtype: this.state.formData.cmbTransactionType,
      //         vac_fromaddr1: this.state.formData.txtDispatchAddress1,
      //         vac_fromaddr2: this.state.formData.txtDispatchAddress2,
      //         vac_fromplace: this.state.formData.cmbDispatchPlace,
      //         vac_frompincode: this.state.formData.txtDispatchPincode,
      //         vac_fromstatecode: FromStateCode,
      //         vac_actualfromstatecode: 0,
      //         vac_totrdname: this.props.cmbCustomer,
      //         vac_togstin: this.state.CustomerData["vac_gstin"],
      //         vac_toaddr1: this.state.formData.txtShipToAddress1,
      //         vac_toaddr2: this.state.formData.txtShipToAddress2,
      //         vac_toplace: this.state.formData.cmbShipToPlace,
      //         vac_topincode: this.state.formData.txtShipToPincode,
      //         vac_tostatecode: ToStateCode,
      //         vac_actualtostatecode: this.props.CustomerStateCode,
      //         dec_totalvalue: this.state.formData.txtTotalValue,
      //         dec_cgstvalue: this.state.formData.txtTotalCGST,
      //         dec_sgstvalue: this.state.formData.txtTotalSGST,
      //         dec_igstvalue: this.state.formData.txtTotalIGST,
      //         dec_cessvalue: 0,
      //         dec_totnonadvolval: 0,
      //         dec_othvalue: 0,
      //         vac_mainhsncode: "",
      //         dec_totInvValue: this.state.formData.txtTotalInvoiceValue,
      //         vac_transmode: this.state.formData.cmbModeofTransportation,
      //         dec_transdistance: this.state.formData.txtApproximateDistanceinKM,
      //         vac_transportername: this.state.formData.cmbTransporterName,
      //         vac_transporterid: this.state.formData.cmbTransporterID,
      //         vac_transdocno: this.state.formData.txtTransporterDocNo,
      //         dat_transdocdate: this.state.formData.dtpTransporterDate,
      //         vac_vehicleno: this.state.formData.cmbVehicleNo,
      //         vac_vehicletype: this.state.formData.cmbVehicleType,
      //       },
      //     };
      //     // console.log("reqData", reqData);
      //     fetchSales(reqData)
      //       .then((res) => {
      //         this.props.updateProcessing(res.data.msgType, res.data.message);
      //         if (res.data.msgType === "success") {
      //           this.props.setEwayBillARDNull();
      //         }
      //       })
      //       .catch((error) => {
      //         console.log("Unknown error occurred in saveEWayBill.", error);
      //       });
      //   });
      // }
    }
  };

  //#endregion function

  render() {
    let bolDisplayOtherSubType = false;
    if (this.state.formData.cmbSubSupplyType === "Others") {
      bolDisplayOtherSubType = true;
    }
    // console.log("this.state.TransporterIDList", this.state.TransporterIDList);
    return (
      <form>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className="title"
        >
          <label htmlFor="Title" style={{ fontSize: "25px", color: "#6f7689" }}>
            <b>Sales E-Way Bill Entry</b>
          </label>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={2}
          marginTop={0}
        >
          <Grid item>
            <CtTxt
              id="txtSupplyType"
              label="Supply Type*"
              value="Outward"
              handleOnChange={this.handleOnChange}
              width={100}
              maxLength={10}
              disabled={true}
            />
          </Grid>
          <Grid item>
            <CtCmb
              id="cmbSubSupplyType"
              label="Sub Supply Type*"
              value={this.state.formData.cmbSubSupplyType}
              handleOnChange={this.handleOnChange}
              items={this.state.SubSupplyTypeList}
              width={200}
              maxLength={100}
              nextCtrlID="cmbSubTypeOtherSpecify"
            />
          </Grid>
          {bolDisplayOtherSubType ? (
            <Grid item>
              <CtCmbEditable
                id="cmbSubTypeOtherSpecify"
                label="Sub Type Other Specify*"
                value={this.state.formData.cmbSubTypeOtherSpecify}
                handleOnChange={this.handleOnChange}
                items={this.state.SubTypeOtherSpecifyList}
                colID="vac_subsupplytypeother"
                width={200}
                maxLength={100}
                nextCtrlID="cmbDocumentType"
              />
            </Grid>
          ) : (
            ""
          )}
          <Grid item>
            <CtCmb
              id="cmbDocumentType"
              label="Document Type*"
              value={this.state.formData.cmbDocumentType}
              handleOnChange={this.handleOnChange}
              items={this.state.DocumentTypeList}
              width={150}
              maxLength={100}
              onKeyDown={this.props.onKeyDown}
              nextCtrlID="txtDocumentNo"
            />
          </Grid>
          <Grid item>
            <CtTxt
              id="txtDocumentNo"
              label="Document No*"
              value={this.state.formData.txtDocumentNo}
              handleOnChange={this.handleOnChange}
              width={150}
              maxLength={10}
              disabled={true}
              nextCtrlID="dtpDocumentDate"
            />
          </Grid>
          <Grid item>
            <CtDtp
              id="dtpDocumentDate"
              label="Document Date*"
              value={this.state.formData.dtpDocumentDate}
              handleOnChange={this.handleOnChange}
              width={130}
              maxLength={10}
              onKeyDown={this.props.onKeyDown}
              nextCtrlID="cmbTransactionType"
              accountYear={localStorage.getItem("ACY")}
              disabled={true}
            />
          </Grid>
          <Grid item>
            <CtCmb
              id="cmbTransactionType"
              label="Transaction Type*"
              value={this.state.formData.cmbTransactionType}
              handleOnChange={this.handleOnChange}
              items={this.state.TransactionTypeList}
              width={250}
              maxLength={100}
              onKeyDown={this.props.onKeyDown}
              nextCtrlID="txtDispatchAddress1"
            />
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={2}
          marginTop={0}
        >
          <Grid item>
            <CtMultiLineText
              id="txtDispatchAddress1"
              label="Dispatch Address 1"
              value={this.state.formData.txtDispatchAddress1}
              handleOnChange={this.handleOnChange}
              width={300}
              maxLength={1000}
              onKeyDown={this.props.onKeyDown}
              nextCtrlID="txtDispatchAddress2"
            />
          </Grid>
          <Grid item>
            <CtMultiLineText
              id="txtDispatchAddress2"
              label="Dispatch Address 2"
              value={this.state.formData.txtDispatchAddress2}
              handleOnChange={this.handleOnChange}
              width={300}
              maxLength={1000}
              onKeyDown={this.props.onKeyDown}
              nextCtrlID="cmbDispatchPlace"
            />
          </Grid>
          <Grid item>
            <CtCmbEditable
              id="cmbDispatchPlace"
              label="Dispatch Place"
              value={this.state.formData.cmbDispatchPlace}
              items={this.state.DispatchPlaceList}
              colID="vac_fromplace"
              handleOnChange={this.handleOnChange}
              width={200}
              maxLength={100}
              nextCtrlID="txtDispatchPincode"
            />
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={2}
          marginTop={0}
        >
          <Grid item>
            <CtTxtNum
              id="txtDispatchPincode"
              label="Dispatch Pincode*"
              value={this.state.formData.txtDispatchPincode}
              handleOnChange={this.handleOnChange}
              width={150}
              maxLength={6}
              onKeyDown={this.props.onKeyDown}
              nextCtrlID="cmbDispatchState"
            />
          </Grid>
          <Grid item>
            <CtCmb
              id="cmbDispatchState"
              label="Dispatch State"
              value={this.state.formData.cmbDispatchState}
              items={this.state.DispatchStateList}
              colID="vac_state"
              handleOnChange={this.handleOnChange}
              width={350}
              maxLength={100}
              nextCtrlID="txtShipToAddress1"
            />
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={2}
          marginTop={0}
        >
          <Grid item>
            <CtMultiLineText
              id="txtShipToAddress1"
              label="Ship To Address 1"
              value={this.state.formData.txtShipToAddress1}
              handleOnChange={this.handleOnChange}
              width={300}
              maxLength={1000}
              onKeyDown={this.props.onKeyDown}
              nextCtrlID="txtShipToAddress2"
            />
          </Grid>
          <Grid item>
            <CtMultiLineText
              id="txtShipToAddress2"
              label="Ship To Address 2"
              value={this.state.formData.txtShipToAddress2}
              handleOnChange={this.handleOnChange}
              width={300}
              maxLength={1000}
              onKeyDown={this.props.onKeyDown}
              nextCtrlID="cmbShipToPlace"
            />
          </Grid>
          <Grid item>
            <CtCmbEditable
              id="cmbShipToPlace"
              label="Ship To Place"
              value={this.state.formData.cmbShipToPlace}
              items={this.state.ShipToPlaceList}
              colID="vac_toplace"
              handleOnChange={this.handleOnChange}
              width={200}
              maxLength={10}
              nextCtrlID="txtShipToPincode"
            />
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={2}
          marginTop={0}
        >
          <Grid item>
            <CtTxtNum
              id="txtShipToPincode"
              label="Ship To Pincode*"
              value={this.state.formData.txtShipToPincode}
              handleOnChange={this.handleOnChange}
              width={150}
              maxLength={6}
              onKeyDown={this.props.onKeyDown}
              nextCtrlID="cmbShipToState"
            />
          </Grid>
          <Grid item>
            <CtCmb
              id="cmbShipToState"
              label="Ship To State"
              value={this.state.formData.cmbShipToState}
              items={this.state.ShipToStateList}
              colID="vac_state"
              handleOnChange={this.handleOnChange}
              width={350}
              maxLength={100}
              nextCtrlID="cmbModeofTransportation"
            />
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={2}
          marginTop={0}
        >
          <Grid item>
            <CtTxtAmt
              id="txtTotalValue"
              label="Total Value"
              value={this.state.formData.txtTotalValue}
              handleOnChange={this.handleOnChange}
              width={160}
              maxLength={10}
              disabled={true}
            />
          </Grid>
          <Grid item>
            <CtTxtAmt
              id="txtTotalCGST"
              label="Total CGST"
              value={this.state.formData.txtTotalCGST}
              handleOnChange={this.handleOnChange}
              width={160}
              maxLength={10}
              disabled={true}
            />
          </Grid>
          <Grid item>
            <CtTxtAmt
              id="txtTotalSGST"
              label="Total SGST"
              value={this.state.formData.txtTotalSGST}
              handleOnChange={this.handleOnChange}
              width={160}
              maxLength={10}
              disabled={true}
            />
          </Grid>
          <Grid item>
            <CtTxtAmt
              id="txtTotalIGST"
              label="Total IGST"
              value={this.state.formData.txtTotalIGST}
              handleOnChange={this.handleOnChange}
              width={160}
              maxLength={10}
              disabled={true}
            />
          </Grid>
          <Grid item>
            <CtTxtAmt
              id="txtTotalInvoiceValue"
              label="Total Invoice Value"
              value={this.state.formData.txtTotalInvoiceValue}
              handleOnChange={this.handleOnChange}
              width={160}
              maxLength={10}
              disabled={true}
            />
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={2}
          marginTop={0}
        >
          <Grid item>
            <CtCmb
              id="cmbModeofTransportation"
              label="Mode of Transportation"
              value={this.state.formData.cmbModeofTransportation}
              handleOnChange={this.handleOnChange}
              items={this.state.ModeofTransportationList}
              width={200}
              maxLength={100}
              onKeyDown={this.props.onKeyDown}
              nextCtrlID="txtApproximateDistanceinKM"
            />
          </Grid>
          <Grid item>
            <CtTxtAmt
              id="txtApproximateDistanceinKM"
              label="Approximate Distance (in KM)*"
              value={this.state.formData.txtApproximateDistanceinKM}
              handleOnChange={this.handleOnChange}
              width={225}
              maxLength={5}
              nextCtrlID="cmbTransporterName"
            />
          </Grid>
          <Grid item>
            <CtBtn
              id="btnApproximateDistanceinKM"
              label="Get Approximate Distance"
              onClick={this.getDistanceFromPincode}
            />
          </Grid>
          <Grid item>
            <CtCmbEditable
              id="cmbTransporterName"
              label="Transporter Name"
              value={this.state.formData.cmbTransporterName}
              items={this.state.TransporterNameList}
              colID="vac_transportername"
              handleOnChange={this.handleOnChange}
              width={200}
              maxLength={100}
              nextCtrlID="cmbTransporterID"
            />
          </Grid>
          <Grid item>
            <CtCmbEditable
              id="cmbTransporterID"
              label="Transporter ID"
              value={this.state.formData.cmbTransporterID}
              items={this.state.TransporterIDList}
              colID="vac_transporterid"
              handleOnChange={this.handleOnChange}
              width={150}
              maxLength={100}
              nextCtrlID="txtTransporterDocNo"
            />
          </Grid>
          <Grid item>
            <CtTxt
              id="txtTransporterDocNo"
              label="Transporter Doc. No."
              value={this.state.formData.txtTransporterDocNo}
              handleOnChange={this.handleOnChange}
              width={160}
              maxLength={100}
              nextCtrlID="dtpTransporterDate"
            />
          </Grid>
          <Grid item>
            <CtDtp
              id="dtpTransporterDate"
              label="Transporter Date"
              value={this.state.formData.dtpTransporterDate}
              handleOnChange={this.handleOnChange}
              width={130}
              maxLength={10}
              onKeyDown={this.props.onKeyDown}
              nextCtrlID="cmbVehicleNo"
            />
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={2}
          marginTop={0}
        >
          <Grid item>
            <CtCmbEditable
              id="cmbVehicleNo"
              label="Vehicle No."
              value={this.state.formData.cmbVehicleNo}
              items={this.state.VehicleNoList}
              colID="vac_vehicleno"
              handleOnChange={this.handleOnChange}
              width={250}
              maxLength={100}
              nextCtrlID="cmbVehicleType"
            />
          </Grid>
          <Grid item>
            <CtCmb
              id="cmbVehicleType"
              label="Vehicle Type"
              value={this.state.formData.cmbVehicleType}
              items={this.state.VehicleTypeList}
              handleOnChange={this.handleOnChange}
              width={200}
              maxLength={100}
            />
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={2}
          marginTop={0}
        >
          <Grid
            item
            display={this.props.userPrivilege.Sales == "R" ? "none" : "block"}
          >
            <CtBtn label="Save" onClick={this.saveEWayBill} />
          </Grid>
          {/* <Grid item>
            <CtBtn label="New" onClick={this.clearInfo} />
          </Grid> */}
        </Grid>
        <br />
        <Grid item>
          <Box display={{ xs: "none" }} style={{ textAlign: "right" }}>
            {this.state.ARD}
          </Box>
        </Grid>
      </form>
    );
  }
}

export default connect(
  mapStatetoProps,
  mapSetActiveMenuToProps
)(HoCtToastContainer(SalesEWayBill));
